import {franc} from 'franc';
export const translationLanguages:Record<string,string>={es:'Español',ca:'Mallorquí / Català',en:'English',de:'Deutsch',fr:'Français',it:'Italiano',pt:'Português'};
export function needsSpanishTranslation(text:string):boolean {
 const clean=text.replace(/https?:\/\/\S+/g,'').trim();
 if(!/\p{L}/u.test(clean)||/^(ok|okay|sí|si|no|hola|gracias|vale|perfecto|buenos días|buenas tardes)[.!\s]*$/i.test(clean))return false;
 if(/[\p{Script=Cyrillic}\p{Script=Arabic}\p{Script=Han}\p{Script=Greek}\p{Script=Hebrew}]/u.test(clean))return true;
 if(/^(thanks|thank you|hello|danke|hallo|bonjour|merci|ciao|grazie|obrigad[oa]|gràcies|bon dia)[.!\s]*$/i.test(clean))return true;
 if(clean.length<80&&/\b(buenos días|buenas tardes|buenas noches|quería|queríamos|tengo|necesito|gracias|mañana|podrías)\b/i.test(clean))return false;
 const language=franc(clean,{minLength:10,only:['spa','cat','eng','deu','fra','ita','por']});
 return language!=='spa'&&language!=='und';
}
